<script setup>
import WizardLayout from '@/Layouts/WizardLayout.vue';
import {onBeforeMount, provide} from 'vue';

onBeforeMount(() => provide('currentStep', 1));

defineProps({
  videoLink: {
    type: String,
    default: null,
  },
});
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <wizard-layout>
    <template #default>
      <div class="grid-2 wizard_grid">
        <div>
          <h3 class="color_theme mb-2">{{ trans('dashboard.integrations.wizard.step_x', {step: 1}) }}</h3>
          <h2 class="h5">{{ trans('dashboard.integrations.wizard.first_step.title') }}</h2>
          <p>{{ trans('dashboard.integrations.wizard.first_step.description') }}</p>
        </div>
        <div v-if="videoLink" class="mr-md-3">
          <div class="video_wrap">
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                :src="videoLink"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <inertia-link class="button" :href="route('wizard.step-2.index')" v-text="trans('common.start')"/>
    </template>
  </wizard-layout>
</template>
